module.exports = __webpack_public_path__ + "static/media/Platinium.1f62ca48.png";